import { withResizeDetector } from 'react-resize-detector/build/withPolyfill'

export default withResizeDetector
